import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { useNavigate } from 'react-router-dom';
import { useIssueStatusDistribution } from '../../hooks/useDashboard';
import Spinner from '../ui/Spinner';

interface Props {
  projectId: string;
  projectKey: string;
}

export default function IssueStatusPieWidget({ projectId, projectKey }: Props) {
  const { data, isLoading } = useIssueStatusDistribution(projectId);
  const navigate = useNavigate();

  if (isLoading) return <WidgetLoader />;

  const chartData = (data ?? []).map((d) => ({
    name: d.name,
    value: d.count,
    color: d.color,
  }));

  const total = chartData.reduce((s, d) => s + d.value, 0);

  const handleClick = (_: unknown, index: number) => {
    const name = chartData[index]?.name;
    if (name) {
      navigate(`/projects/${projectKey}/issues?filter=status = ${name}`);
    }
  };

  return (
    <div className="h-full flex flex-col">
      <h3 className="text-sm font-semibold text-gray-700 mb-2">작업 상태 분포</h3>
      {total === 0 ? (
        <div className="flex-1 flex items-center justify-center text-sm text-gray-400">데이터 없음</div>
      ) : (
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={chartData}
              cx="50%"
              cy="50%"
              innerRadius="40%"
              outerRadius="70%"
              dataKey="value"
              onClick={handleClick}
              cursor="pointer"
            >
              {chartData.map((entry, index) => (
                <Cell key={index} fill={entry.color ?? '#D1D5DB'} />
              ))}
            </Pie>
            <Tooltip
              formatter={(value, name) => [`${value}건`, name as string]}
            />
            <Legend
              verticalAlign="bottom"
              height={36}
              formatter={(value: string) => <span className="text-sm text-gray-600">{value}</span>}
            />
          </PieChart>
        </ResponsiveContainer>
      )}
    </div>
  );
}

function WidgetLoader() {
  return (
    <div className="flex items-center justify-center h-full">
      <Spinner className="size-6" />
    </div>
  );
}
